/* ------------------------------------------------------------------
   CRANTAIGER — signup source attribution
   Added 2026-09-01.
   Revised 2026-09-08 — wear-test form now also carries van- and pay- tags
   (Field Test Program cohort classification). See ct-waitlist.liquid.
   Revised 2026-09-14 — Homepage Wave 1. Two changes, both in wireHero:
     1. The hero form id is no longer hard-coded to ct-hero-size-form.
        Wave 1 introduced sections/ct-hero-v3.liquid with the id
        ct-hero-v3-form. Until this revision that form received NO src-
        tag at all, silently — the listener was bound to an id that is
        not on the page. Both ids are now wired, so v2.5 and v3.0 behave
        identically and either theme can be rolled back to.
     2. The hero now carries an OPTIONAL occupation <select>.
        Values are the same eight job-* values used by the Field Test
        form, deliberately — one vocabulary, one segment, one number at
        the November gate. Do not introduce a job- value here that does
        not exist in ct-waitlist.liquid.

   WHY THIS EXISTS
   Every signup in admin looks identical. In November the demand gate has
   to answer "which channel actually produced this list?" — Reddit, IG,
   direct, or nothing. Without a source tag written at signup time that
   question is unanswerable after the fact, and the whole 30-day channel
   test becomes unmeasurable.

   HOW
   1. First touch wins. The source is read from ?utm_source / ?src / ?ref,
      or failing that from the referring hostname, and stored once in
      localStorage. A visitor who arrives from Reddit, leaves, and comes
      back directly two days later is still counted as Reddit.
   2. On submit, the source is appended to contact[tags] as src-<value>.

   FAILURE MODE — DELIBERATE, AND ORDERED
   Every block is wrapped in try/catch and every helper returns early.
   The hero size <select> keeps name="contact[tags]" in the markup, so a
   no-JS submit still records the size. The rule is a ladder:

     script blocked / throws  -> waitlist + founding-batch-001 + size-US-*
                                 land. job- and src- are lost.
     job left unselected      -> everything else lands. job- is absent.
     everything works         -> waitlist, founding-batch-001, size-US-*,
                                 job-*, src-*.

   The size tag, which is the one field the business genuinely cannot
   lose, is never on the failure path. A missing src- tag costs a report
   column. A missing job- tag costs cohort resolution. A missing size-
   tag costs the size curve. That ordering is why the select keeps its
   name and the job field does not have one.
   ------------------------------------------------------------------ */
(function () {
  var KEY = 'ct_src';

  /* Hero forms, newest first. Both are wired so a rollback to v2.5 keeps
     attribution working. Adding a new hero section? Add its id here. */
  var HERO_FORMS = ['ct-hero-v3-form', 'ct-hero-size-form'];

  function clean(v) {
    return String(v)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 24);
  }

  /* --- capture, first touch wins --- */
  try {
    var params = new URLSearchParams(window.location.search);
    var explicit = params.get('utm_source') || params.get('src') || params.get('ref');

    if (explicit) {
      localStorage.setItem(KEY, clean(explicit));
    } else if (!localStorage.getItem(KEY) && document.referrer) {
      var host = new URL(document.referrer).hostname.replace(/^www\./, '');
      if (host && host.indexOf(window.location.hostname) === -1) {
        localStorage.setItem(KEY, clean(host.split('.')[0]));
      }
    }
  } catch (e) {}

  window.ctSource = function () {
    try {
      return localStorage.getItem(KEY) || 'direct';
    } catch (e) {
      return 'direct';
    }
  };

  /* --- hero form: append job- and src- to the <select> value ---
     The size select carries name="contact[tags]" so that a no-JS submit
     still records the size. We therefore cannot rewrite select.value
     directly (a value with no matching <option> submits empty). Instead
     we build the combined string, add it as a hidden field, and only
     then strip the name off the select, so the two never both submit.

     The job select deliberately carries NO name attribute — same pattern
     as the Field Test form. Two elements named contact[tags] in one form
     would collide and the size tags would be the casualty. */
  function wireHeroForm(id) {
    var form = document.getElementById(id);
    if (!form || form.dataset.ctWired) return;
    form.dataset.ctWired = '1';

    form.addEventListener('submit', function () {
      try {
        var sel = form.querySelector('select[name="contact[tags]"]');
        if (!sel || !sel.value) return;   // no size: touch nothing, let the browser block it

        var parts = [sel.value];

        /* Class, not id: the theme editor can render two hero sections at
           once and duplicate ids would make the wrong one win. */
        var job = form.querySelector('.cth-job');
        if (job && job.value) parts.push(job.value);

        parts.push('src-' + window.ctSource());

        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'contact[tags]';
        hidden.value = parts.join(',');
        form.appendChild(hidden);
        sel.removeAttribute('name');
      } catch (e) {}
    });
  }

  function wireHero() {
    for (var i = 0; i < HERO_FORMS.length; i++) {
      wireHeroForm(HERO_FORMS[i]);
    }
  }

  /* --- wear-test form: build the whole tag string on submit ---
     Here the hidden field ships with a safe default already in it
     (weartest,founding-batch-001), so a JS failure still produces a
     usable, findable customer record — just without job/size/source.
     2026-09-08: van- (vehicle in/out per day) and pay- (who pays for
     boots) are the two Field Test Program cohort classifiers. Same
     failure logic: optional, never block the submit. */
  function wireWearTest() {
    var form = document.getElementById('ct-weartest-form');
    if (!form || form.dataset.ctWired) return;
    form.dataset.ctWired = '1';

    form.addEventListener('submit', function () {
      try {
        var tags = document.getElementById('ct-wt-tags');
        if (!tags) return;

        var job = document.getElementById('ct-wt-job');
        var van = document.getElementById('ct-wt-van');
        var pay = document.getElementById('ct-wt-pay');
        var size = document.getElementById('ct-wt-size');
        var parts = ['weartest', 'founding-batch-001'];

        if (job && job.value) parts.push(job.value);
        if (van && van.value) parts.push(van.value);
        if (pay && pay.value) parts.push(pay.value);
        if (size && size.value) parts.push(size.value);
        parts.push('src-' + window.ctSource());

        tags.value = parts.join(',');
      } catch (e) {}
    });
  }

  function wire() {
    wireHero();
    wireWearTest();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }

  /* Sections re-render in the theme editor without a page load. */
  document.addEventListener('shopify:section:load', wire);
})();
